import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/pages/Layout';
import routeWorkbench from './modules/route-workbench';
import routeMessage from './modules/route-message';
// import routeProject from './modules/route-project';
import routeBusiness from './modules/route-business';
import routeProcess from './modules/route-process';
import routeComponent from './modules/route-component';
import routeApplication from './modules/route-application';
import routeDocument from './modules/route-document';
import routeOperation from './modules/route-operation';
import routeSystem from './modules/route-system';
import routeCustomer from './modules/route-customer';
import routeMySetting from './modules/route-mySetting';
import routeOffice from './modules/route-office';
import { getCurrentUserInfo } from '@/data-model';
import { getGlobalConf } from '@/utils/grocer';
// import jsCookies from 'js-cookie';

const routerBasePath = getGlobalConf().routerBasePath;
const ENV = process.env.NODE_ENV;

export const getRoutes = () => {
    return [
        {
            path: '/login',
            component: () => import('@/pages/Login'),
            isShow: false,
            name: 'login',
            meta: {
                title: '添加表单',
                icon: 'table'
            }
        },
        {
            path: '/registeFirst',
            component: () => import('@/pages/Registe/RegisteFirst'),
            // redirect: 'noredirect',
            isShow: false,
            name: 'registeFirst',
            meta: {
                title: '用户注册',
                icon: 'beer'
            }
        },
        {
            path: '/registeSecond/:userId',
            component: () => import('@/pages/Registe/RegisteSecond'),
            isShow: false,
            name: 'registeSecond',
            meta: {
                title: '录入企业信息',
                icon: 'beer'
            }
        },
        {
            path: '/forhelp',
            component: () => import('@/pages/static/Help'),
            isShow: false,
            name: 'forhelp',
            meta: {
                title: '系统帮助',
                icon: 'table'
            }
        },
        {
            path: '/expAppStore',
            component: () => import('@/pages/static/ExpAppStore'),
            isShow: false,
            name: 'expAppStore',
            meta: {
                title: '应用体验商店',
                icon: 'table'
            }
        },
        {
            path: '/businessSystem',
            component: () => import('@/pages/business/BusinessSystem'),
            isShow: false,
            name: 'businessSystem',
            meta: {
                title: '应用系统',
                icon: 'table'
            }
        },
        {
            path: '/dashBoradCenter',
            component: () => import('@/pages/business/DashBoradCenter'),
            isShow: false,
            name: 'dashBoradCenter',
            meta: {
                title: '仪表盘中心',
                icon: 'table'
            }
        },
        {
            path: '/gateWay',
            component: () => import('@/pages/workbench/GateWay'),
            isShow: false,
            name: 'gateWay',
            meta: {
                title: '门户',
                icon: 'table'
            }
        },
        {
            path: '/gateWay3',
            component: () => import('@/pages/workbench/GateWay3'),
            isShow: false,
            name: 'gateWay3',
            meta: {
                title: '门户二',
                icon: 'table'
            }
        },
        {
            path: '/gateWay4',
            component: () => import('@/pages/workbench/GateWay4'),
            isShow: false,
            name: 'gateWay4',
            meta: {
                title: '门户三',
                icon: 'table'
            }
        },
        {
            path: '/partyBuilding',
            component: () => import('@/pages/workbench/PartyBuilding'),
            isShow: false,
            name: 'partyBuilding',
            meta: {
                title: '党建',
                icon: 'table'
            }
        },
        {
            path: '/authentication',
            component: () => import('@/pages/system/authentication/Authentication'),
            isShow: false,
            name: 'authentication',
            meta: {
                title: '权限验证',
                icon: 'table'
            }
        },
        {
            path: '/DataWarehousingPreviewFull',
            component: () => import('@/components/DataWarehousing/DataWarehousingPreviewFull'),
            isShow: false,
            name: 'DataWarehousingPreviewFull',
            meta: {
                title: '仪表盘',
                icon: 'table'
            }
        },
        {
            path: '/linkFormDetail/:modelId/:formId/:dataId',
            component: () => import('@/pages/business/BusinessApplication/LinkFormDetail'),
            isShow: false,
            name: 'linkFormDetail//:modelId/:formId/:dataId',
            meta: {
                title: '表单详情',
                icon: 'table'
            }
        },
        {
            path: '/forgetPwd',
            component: () => import('@/pages/ForgetPwd/ForgetPwd'),
            // redirect: 'noredirect',
            isShow: false,
            name: 'forgetPwd',
            meta: {
                title: '忘记密码',
                icon: 'beer'
            }
        }]
        .concat(routeWorkbench)
        .concat(routeOffice)
        .concat(routeOperation)
        .concat(routeMessage)
    // .concat(routeProject)
        .concat(routeBusiness)
        .concat(routeProcess)
        .concat(routeComponent)
        .concat(routeApplication)
        .concat(routeDocument)
        // .concat(routeCustomer)
        .concat(routeMySetting)
        .concat(routeSystem);
};

function setDynamicRoutes () {
    // let userType = jsCookies.get('currentUserType');
    let currentUserStr = sessionStorage.getItem('currentUserInfo');
    if (!currentUserStr || currentUserStr === 'undefined') {
        return getRoutes();
    }
    let currentUserInfo = JSON.parse(currentUserStr);
    // console.log('getRouteCustomer-userType:' + currentUserInfo.userType);
    if (currentUserInfo.userType === 1) {
        routeCustomer[0].component = Layout;
        return getRoutes().concat(routeCustomer);
    } else {
        return getRoutes();
    }
};

async function getUserInfo () {
    let userInfo = await getCurrentUserInfo();
    // jsCookies.remove('currentUserType');
    // jsCookies.set('currentUserType', tempUser.userType);
    sessionStorage.removeItem('currentUserInfo');
    let str = JSON.stringify(userInfo);
    sessionStorage.setItem('currentUserInfo', str);
    localStorage.setItem('currentUserInfo', str);
};

Vue.use(Router);
const router = new Router({
    scrollBehavior: () => ({ y: 0 }),
    mode: ENV === 'development' ? 'hash' : 'history',
    // routes: menus,
    // mode: 'history',
    // routes: menus.map((item) => {
    //     if (/^\/(\w)/.test(item.path)) {
    //         item.path = `${BASE_PATH}${item.path}`;
    //     }
    //     return item;
    // })
    routes: [
        {path: '*', component: () => import('@/pages/Login')}
    // ].concat(getRoutes())
    ].concat(setDynamicRoutes()).map((item) => {
        if (/^\/(\w)/.test(item.path)) {
            item.path = `${routerBasePath}${item.path}`;
        }
        return item;
    })
});

router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
// console.log(to);
// console.log(next);
// console.log(from);
    // 缓存不用展现左侧菜单的路由列表
    let m = {'routeWorkbench': routeWorkbench[0].children};
    let str = JSON.stringify(m);
    sessionStorage.setItem('noLeftMenu', str);

    // console.log(to);
    // console.log(from);
    // console.log(next);
    if (from.path === '/login') { // TODO: 登录成功后设置本地缓存，使用缓存进行判断逻辑
        getUserInfo();
        // 处理逻辑
    }
    // router.options.routes.length=0;
    // routeCustomer[0].component = Layout;
    // router.options.routes.push(getRoutes().concat(routeCustomer));
    // console.log(router);
    // router.addRoutes(routeCustomer); // 动态添加可访问路由表
    // console.log(router);
    // next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace:
    // Router.addRoutes(getRoutes().concat(routeCustomer));
    next();// 继续进入路由
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js